import React, { useState, useEffect } from "react";
import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer } from "recharts";

const DirectorApplicantsChart = ({
  pieChartData,
  totalApplicantsCount,
  COLOR_MAP
}) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className="dd-card dd-chart-card">
      <div className="dd-card-header">
        <h2>Applicants Overview</h2>
        <select className="dd-select">
          <option>Last 7 Days</option>
          <option>This Month</option>
        </select>
      </div>
      
      <div 
        className="dd-chart-container" 
        style={{ position: "relative", width: "100%", display: "flex", alignItems: "center", justifyContent: "center" }}
      >
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Tooltip
              content={({ active, payload }) => {
                if (active && payload && payload.length) {
                  const data = payload[0];
                  const fillColor = COLOR_MAP[data.name] || "#3b82f6";
                  return (
                    <div style={{ background: "rgba(15, 15, 15, 0.95)", border: "1px solid rgba(255,255,255,0.12)", borderRadius: "12px", padding: "8px 14px", boxShadow: "0 8px 24px rgba(0,0,0,0.5)" }}>
                      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                        <span style={{ width: "8px", height: "8px", borderRadius: "50%", backgroundColor: fillColor }}></span>
                        <p style={{ margin: 0, color: "#fff", fontSize: "12px", fontWeight: 600 }}>{data.name}</p>
                      </div>
                      <p style={{ margin: "4px 0 0 0", color: "#9ca3af", fontSize: "11px" }}>
                        Count: <span style={{ color: "#fff", fontWeight: 700 }}>{data.value}</span>
                      </p>
                    </div>
                  );
                }
                return null;
              }}
            />

            <Pie
              data={pieChartData.length > 0 ? pieChartData : [{ name: "No Data", value: 1 }]}
              cx="50%"
              cy="50%"
              innerRadius={isMobile ? 54 : 62}
              outerRadius={isMobile ? 76 : 85}
              paddingAngle={4}
              dataKey="value"
              nameKey="name"
              cornerRadius={5}
              stroke="none"
            >
              {pieChartData.map((entry, index) => (
                <Cell
                  key={`cell-${index}`}
                  fill={COLOR_MAP[entry.name] || "#3B82F6"}
                />
              ))}
            </Pie>
          </PieChart>
        </ResponsiveContainer>

        <div style={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)", textAlign: "center", pointerEvents: "none" }}>
          <span style={{ fontSize: "24px", fontWeight: "800", color: "#ffffff", display: "block", lineHeight: 1 }}>{totalApplicantsCount}</span>
          <span style={{ fontSize: "10px", fontWeight: "600", color: "#9ca3af", textTransform: "uppercase", letterSpacing: "0.8px", marginTop: "4px", display: "block" }}>Total</span>
        </div>
      </div>

      <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "14px", marginTop: "12px", flexWrap: "wrap" }}>
        <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
          <span style={{ width: "8px", height: "8px", borderRadius: "50%", backgroundColor: "#ffb020" }}></span>
          <span style={{ fontSize: "12px", color: "#9ca3af", fontWeight: "500" }}>Pending</span>
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
          <span style={{ width: "8px", height: "8px", borderRadius: "50%", backgroundColor: "#a855f7" }}></span>
          <span style={{ fontSize: "12px", color: "#9ca3af", fontWeight: "500" }}>Resubmit</span>
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
          <span style={{ width: "8px", height: "8px", borderRadius: "50%", backgroundColor: "#00c781" }}></span>
          <span style={{ fontSize: "12px", color: "#9ca3af", fontWeight: "500" }}>Shortlisted</span>
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
          <span style={{ width: "8px", height: "8px", borderRadius: "50%", backgroundColor: "#ff4d4f" }}></span>
          <span style={{ fontSize: "12px", color: "#9ca3af", fontWeight: "500" }}>Rejected</span>
        </div>
      </div>
    </div>
  );
};

export default DirectorApplicantsChart;
